const LangChinaFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <rect width="16" height="11" fill="#DE2910" />
    <path d="M2 2L3 1L4 2L3 3L2 2Z" fill="#FFDE00" />
    <path d="M5 1L6 1L6.5 2L6 3L5 3L4.5 2L5 1Z" fill="#FFDE00" />
    <path d="M5 5L6 4L7 5L6 6L5 5Z" fill="#FFDE00" />
    <path d="M3 4L4 4L4.5 5L4 6L3 6L2.5 5L3 4Z" fill="#FFDE00" />
    <path d="M3 7L4 6L5 7L4 8L3 7Z" fill="#FFDE00" />
  </svg>
);

export default LangChinaFlag;
